import { Quotation } from 'data-layer-cr/dist/models';
import { useCallback, useEffect, useState } from 'react';
import {
  FAILURE_FETCH,
  INITIAL_FETCH,
  REQUESTING_FETCH,
  SUCCESS_FETCH,
} from 'src/constants/fetchStatus';
import { ERROR_EMISSION } from 'src/constants/quotationStatus';
import processRequest from 'src/services/processRequest';

interface GetLatestStatusErrorResponse {
  statusId: number;
  errorTitle: string;
  errorMessage: string;
  statusCode: number;
  isError: boolean;
}

interface UseGetLatestStatusError {
  fetchStatus: string;
  data: GetLatestStatusErrorResponse | undefined;
}

export const useGetLatestStatusError = (
  quotation: Quotation,
): UseGetLatestStatusError => {
  const [fetchStatus, setFetchStatus] = useState(INITIAL_FETCH);
  const [data, setData] = useState<GetLatestStatusErrorResponse>();
  const getLatestStatusError = useCallback(() => {
    (async () => {
      if (quotation.status.id !== ERROR_EMISSION) return;
      try {
        setFetchStatus(REQUESTING_FETCH);
        const response = await processRequest<GetLatestStatusErrorResponse>({
          method: 'GET',
          url: `PolicyEmission/getLatestStatusError?quotationId=${quotation.id}`,
        });
        setFetchStatus(SUCCESS_FETCH);
        setData(response);
      } catch {
        setFetchStatus(FAILURE_FETCH);
      }
    })();
  }, [quotation]);

  useEffect(() => {
    if (fetchStatus === INITIAL_FETCH) getLatestStatusError();
  }, [fetchStatus, getLatestStatusError, quotation]);

  return {
    data,
    fetchStatus,
  };
};

export default useGetLatestStatusError;
